/**
 * What a password field looks like with the reveal on and with it off.
 *
 * A model file for two strings and a type name looks like ceremony until you
 * notice what it pins: the input's `type`. The whole safety of this control is
 * that it is `password` unless somebody deliberately pressed the button, and a
 * refactor that inverted the boolean would leave a field that reads correctly,
 * behaves correctly, and shows the password to the room by default. That is not
 * a bug a screenshot catches, because the screenshot is of somebody's password.
 */

/** The `type` the input carries. Never anything but these two. */
export type RevealType = 'password' | 'text'

export function revealType(revealed: boolean): RevealType {
  return revealed ? 'text' : 'password'
}

/**
 * The button's accessible name.
 *
 * It says what pressing does, not what the field is currently doing. A toggle
 * named for its state ("Password is hidden") leaves somebody working out what
 * the button will do to it, and a screen reader user hears the name at the
 * moment they are deciding whether to press.
 *
 * `aria-pressed` carries the state, so the two together say both halves.
 */
export function revealLabel(revealed: boolean): string {
  return revealed ? 'Hide password' : 'Show password'
}
